// extracted by mini-css-extract-plugin
module.exports = {"container":"QuizPage2_container__16jb7","header":"QuizPage2_header__1PAu6","description":"QuizPage2_description__ceRlp"};